'use strict';

/**
 * Checks if the @param value is an array-like object
 *
 * @param {*} value
 * @returns {boolean}
 */
function isArrayLike(value) {
    return value && typeof value.length === 'number' && (value.length === 0 || typeof value[0] !== 'undefined');
}

module.exports = isArrayLike;
